import React from 'react';
import styled from 'styled-components';
import { ProgressPie } from 'components/atoms/progress-pie';

const Wrapper = styled.div`
  svg {
    margin-right: var(--spacing-01);
  }
`;

interface ProgressProps {
  id: number;
  type: 'default' | 'success' | 'warn' | 'error' | undefined;
}

/**
 * Extension of progress Pie, where instead of pie-like status,
 * Status circle is filled with the color to indicate the overall status.
 * @param data Array - Array of objects with "type" key
 * */
export const RecentStatus = ({ data }) => {
  const StatusPies = data.map((pie: ProgressProps) => (
    <ProgressPie
      key={pie.id}
      backgroundFill
      className="pie--status"
      type={pie.type}
    />
  ));

  return <Wrapper>{StatusPies}</Wrapper>;
};
